import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { District } from '@asambleas-models/district.model';
import { Sectional } from '@asambleas-models/sectional.model';
import { Church } from '@asambleas-models/church.model';
import { Role } from '@asambleas-models/role.model';
import { RegistrationService } from '@asambleas-services/registration/registration.service';
import { IglesiasService } from '@asambleas-services/iglesias/iglesias.service';
import { AxisDistrictDirector } from '@asambleas-models/AxisDistrictDirector';
import { RolesService } from '@asambleas-services/roles/roles.service';
import { SectionalCoordinatorPastoral } from '@asambleas-models/SectionalCoordinatorPastoral';
import { LoginService } from '@asambleas-services/login/login.service';

@Component({
  selector: 'app-filters-by-churches',
  templateUrl: './filters-by-churches.component.html',
  styleUrls: ['./filters-by-churches.component.scss']
})
export class FiltersByChurchesComponent implements OnInit {

  @Output() churchesEvent = new EventEmitter<Church[]>();

  districts: District[] = [];
  sectionals: Sectional[] = [];
  cities: any[] = [];
  churches: Church[] = [];

  districtValue: number;
  sectionalValue: number;
  cityValue: number;
  churchValue: number;

  role: Role;

  constructor(private registrationService: RegistrationService,
    private _loginService: LoginService,
    private _iglesiasService: IglesiasService,
    private _rolesService: RolesService, ) { }

  ngOnInit() {

    this.role = this._loginService.getInfoRole();
    console.log('rol al comienzo', this.role);

    this.registrationService.getDistricts()
      .subscribe((data: District[]) => {
        this.districts = data;
      })

    this._iglesiasService.getAllChurches()
      .subscribe((data: Church[]) => {
        this._iglesiasService.allChurches = data;

        //console.log('role', this.role);

        if (this.role.level == '2') {
          this._rolesService.getDirectorDistrital(this.role.pivot.id)
            .subscribe((data: AxisDistrictDirector) => {
              //console.log('data info', data);
              this.districtValue = data.district_id;
              this.changeDistrict(this.districtValue);
            })
        }
        else if (this.role.level == '3') {
          this._rolesService.getSectionalCoordinatorPastoral(this.role.pivot.id)
            .subscribe((data: SectionalCoordinatorPastoral) => {

              //console.log('data info sectional', data);

              this.districtValue = data.sectional.district.id;
              this.changeDistrict(this.districtValue);

              this.sectionalValue = data.sectional_id;
              this.changeSectional(this.sectionalValue);

            })
        }

      })
  }

  changeDistrict(districtValue) {
    //console.log('Filtrar por distrito', districtValue);

    this.cities = [];
    this.churches = [];

    this._iglesiasService.getChurchesByDistrict(districtValue)
      .then((data: Church[]) => {
        //console.log('ejecutando');

        this.churchesEvent.emit(data);

      }, (error) => {
        console.log('Hubo un error distritos');
      });

    if (districtValue) {
      this.registrationService.getDistrictDataById(districtValue)
        .subscribe((districtData: any) => {

          this.sectionals = districtData.sectionals

        });
    }

  }

  changeSectional(sectionalValue) {
    //console.log('Filtrar por seccional', sectionalValue);

    this.churches = [];

    this._iglesiasService.getChurchesBySectional(sectionalValue)
      .then((data: Church[]) => {
        this.churchesEvent.emit(data);
      })
      .catch(() => {
        console.log('Hubo un error seccionales');
      })

    this.registrationService.getSectionalDataById(sectionalValue)
      .subscribe((data: any) => {
        this.cities = data.cities;
      }, (error) => {
        console.log('Hubo un error');
      })

  }

  changeCity(cityValue) {
    this.churches = [];

    this._iglesiasService.getChurchesByCity(cityValue)
      .then((data: Church[]) => {

        this.churches = data;

        this.churchesEvent.emit(data);

      })
      .catch((error) => {
        console.log('Hubo un error');
      })
  }

  changeChurch(churchValue) {
    this._iglesiasService.getChurchById(churchValue)
      .then((church: Church) => {

        let data: Church[] = [];
        data.push(church);

        this.churchesEvent.emit(data);
      })
      .catch((error) => {
        console.log('No se encontró la iglesia');

        //this.filterMinistersByChurches([]);
      })
  }

  clearFilters() {
    this.churchValue = null;
    //this.churches.length = 0;

    this.cityValue = null;
    //this.cities.length = 0;

    this.sectionalValue = null;
    //this.sectionals.length = 0;

    this.districtValue = null;

    this._iglesiasService.getAllChurches()
      .subscribe((data: Church[]) => {
        this.churchesEvent.emit(data);
      }, (error) => {
        console.log('Hubo un error');
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/filters-by-churches/filters-by-churches.component.ts